import { ComponentType } from "react";

type Props = {
  label: string;
  icon: ComponentType<{ className?: string }>;
  onClick: () => void;
  hasAlert?: boolean;
};

export function IconButton({ label, icon: Icon, onClick, hasAlert }: Props) {
  return (
    <div className="relative group shrink-0">
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className="p-2 rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
      >
        <Icon className="w-5 h-5" />
      </button>
      {hasAlert && (
        <span className="pointer-events-none absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white" />
      )}
      <span
        role="tooltip"
        className="pointer-events-none absolute top-full left-1/2 -translate-x-1/2 mt-1.5 z-20 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {label}
      </span>
    </div>
  );
}
